<template>
  <SogButton
    tooltip="Gdv-Nachricht runterladen"
    @click="onDownload"
  >
    {{ item }}
  </SogButton>
</template>
<script setup lang="ts">
import SogButton from "@/shared/ui/SogButton.vue";
import apiVehicleRegistration from "@/modules/VehicleRegistration/api";
import { useSpinner } from "@/shared/composables/SogSpinner";

const _spinner = useSpinner();

// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface Props {
  item: string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
  item: undefined,
});

//"21bbfb259545435ab1b9a19efbb3750d"
async function onDownload() {
  if (!props.item) return;
  try {
    _spinner.show();
    await apiVehicleRegistration.downloadGdvMessageFile(props.item);
  } finally {
    _spinner.hide();
  }
}
</script>
<style scoped />
